import LinkIcon from './LinkIcon';
export default LinkIcon;